import PropTypes from "prop-types";

import {
  Agree,
  Disagree,
  SomewhatAgree,
  SomewhatDisagree,
  StronglyAgree,
  StronglyDisagree,
} from "../../utils/Constant";
import P from "../Paragraph";
import StarRating from "../StarRating";

import "./style.scss";

const DEFAULT_LABELS = [
  StronglyDisagree,
  Disagree,
  SomewhatDisagree,
  SomewhatAgree,
  Agree,
  StronglyAgree,
];

const StarLikertScale = props => {
  const {
    options = DEFAULT_LABELS,
    value = 0,
    onChange,
    disabled = true,
    name = "likert",
  } = props;

  const handleSelect = index => {
    if (!disabled && onChange) {
      onChange(index + 1);
    }
  };

  return (
    <table className="rate-level-table">
      <thead>
        <tr>
          {options.map((_, index) => (
            <th key={index} style={{ textAlign: "center" }}>
              <StarRating
                size={20}
                initialValue={1 + index}
                count={1 + index}
                disabled={true}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {options.map((item, index) => (
            <td
              key={index}
              style={{ textAlign: "center", verticalAlign: "top" }}
            >
              <div className="rate-level-table__mb-rating">
                <StarRating
                  size={20}
                  initialValue={1 + index}
                  count={1 + index}
                  disabled={true}
                />
              </div>
              <P>{item}</P>
              {!disabled && (
                <input
                  type="radio"
                  name={name}
                  value={index + 1}
                  checked={value === index + 1}
                  onChange={() => handleSelect(index)}
                  style={{ marginTop: 4 }}
                />
              )}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

StarLikertScale.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

export default StarLikertScale;
